import { render, staticRenderFns } from "./resume-extra-charges.vue?vue&type=template&id=16f582c9&scoped=true&"
import script from "./resume-extra-charges.vue?vue&type=script&lang=js&"
export * from "./resume-extra-charges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f582c9",
  null
  
)

export default component.exports